import { CruiseSaleType } from './form-type';

export function totalCruiseRescheduleCalculation(
  cruiseSales: CruiseSaleType[],
) {
  const total = cruiseSales.reduce((prev, curr) => {
    //details
    const detail = curr.cruiseSaleDetails
      .filter((detail) => detail.isSelected)
      .reduce(
        (prevDetail, currDetail) =>
          prevDetail +
          currDetail.basicFare +
          currDetail.portCharge +
          currDetail.tax +
          currDetail.tipping,
        0,
      );

    //addons
    const addons = curr.cruiseSaleAddOns
      .filter((addons) => addons.isSelected)
      .reduce((prevAddOns, currAddOns) => prevAddOns + currAddOns.price, 0);

    return prev + addons + detail;
  }, 0);
  return total;
}
